<template>
  <div class="h-100 d-flex flex-column">
    <AppLogoAppBar hide-profile-if-not-logged-in />
    <div class="d-flex flex-column align-center justify-center flex-grow-1 px-6">
      <v-card
        flat
        class="border-a pa-11 d-flex flex-column gap-4"
      >
        <div class="text-center">
          <h2>{{ $t(`${translationPath}.title`) }}</h2>
        </div>
        <v-img
          contain
          class="mx-auto"
          :max-height="$vuetify.breakpoint.smAndDown ? '120' : '180'"
          :src="require('@/assets/confused_gripr_guy.svg')"
          :alt="imageAlt"
        />
        <div
          class="text-center"
          v-html="$t(`${translationPath}.subTitle`)"
        ></div>
        <slot name="actions">
          <div class="d-flex flex-wrap justify-center gap-2">
            <v-btn
              color="primary"
              @click="goHome"
              depressed
            >
              {{ $t("common.goHome") }}
            </v-btn>
            <v-btn
              color="background"
              depressed
              :href="`mailto:${$constant.CONTACT_EMAIL}`"
            >
              {{ $t("common.contactUs") }}
            </v-btn>
          </div>
        </slot>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppBaseErrorPage",
  props: {
    translationPath: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
      default: "Gripr guy shrugging",
    },
  },
  methods: {
    goHome() {
      window.location.href = "/";
    },
  },
};
</script>
